import './App.css';
import  { BrowserRouter ,Routes, Route} from 'react-router-dom'

// User Components
import Home from './Components/Home/Home';
import MoviePage from './Components/MoviePage/MoviePage';
import TheatreList from './Components/TheatreList/TheatreList';
import TheatreHall from './Components/TheaterHall/TheatreHall';
import PaymentPage from './Components/PaymentPage/PaymentPage';
import AllMovies from './Components/AllMovies/AllMovies';
import Login from './Components/LoginSignup/Login';
import Register from './Components/LoginSignup/Register';

// Admin components
import Addmovie from './Components/Admin/Addmovie';
import AddTheatre from './Components/Admin/AddTheatre';
import GetAllTheatres from './Components/Admin/GetAllTheatres';
import AddShow from './Components/Admin/AddShow';
import AdminHome from './Components/Admin/AdminHome';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
            {/* User routes  */}
            <Route path='/' element={<Home />} ></Route>
            <Route path='/movie-page/:movieId' element={<MoviePage />} ></Route>
            <Route path='/theatre-list/:mId' element={<TheatreList />} ></Route>
            <Route path='/book-tickets' element={<TheatreHall />}></Route>
            <Route path='/payment' element={<PaymentPage />} ></Route>
            <Route path='/all-movies' element={<AllMovies />} ></Route>
            <Route path='/login' element={<Login />} ></Route>
            <Route path='/register' element={<Register />} ></Route>


            {/* Admin routes */}
            <Route path='/admin' element={< AdminHome />} ></Route>
            <Route path='/admin/addmovie' element={< Addmovie />} ></Route>
            <Route path='/admin/addtheatre' element={< AddTheatre />} ></Route>
            <Route path='/admin/getalltheatres' element={< GetAllTheatres />} ></Route>
            <Route path='/admin/addshow/:theatreId' element={< AddShow />} ></Route>

        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
